export default function handleStringToNum(value:any){
    if (value !== "") {
        return parseFloat(value);
      } else {
        return value;
      }
}